export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-like-c59613c8349fc989810558b09bd20aa4.png";